/**
 * api.js — the Tool Builder's calls to /api/user-tools (see clarab/routes/userToolRoutes.js).
 */
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
const base = `${API_URL}/api/user-tools`;

/** Fired on window after a tool is created, versioned, deleted or re-statused — the Tools rail reloads on it. */
export const USER_TOOLS_CHANGED = 'clara:user-tools-changed';
const changed = (data) => {
  try { window.dispatchEvent(new Event(USER_TOOLS_CHANGED)); } catch { /* no window (tests) */ }
  return data;
};

export const toolsApi = {
  procedure: (ref) => axios.get(`${base}/procedure`, { ...auth(), params: { ref } }).then((r) => r.data),
  searchProcedures: (q) => axios.get(`${base}/procedures`, { ...auth(), params: { q } }).then((r) => r.data),
  // a generation is a JOB: POST answers { jobId } at once, GET /generate/:jobId gives the stage while it runs and the result when done
  generate: (body) => axios.post(`${base}/generate`, body, { ...auth(), timeout: 60 * 1000 }).then((r) => r.data),
  generateStatus: (jobId) => axios.get(`${base}/generate/${jobId}`, { ...auth(), timeout: 30 * 1000 }).then((r) => r.data),
  refine: (body) => axios.post(`${base}/refine`, body, { ...auth(), timeout: 4 * 60 * 1000 }).then((r) => r.data),
  list: () => axios.get(base, auth()).then((r) => r.data),
  get: (id) => axios.get(`${base}/${id}`, auth()).then((r) => r.data),
  create: (body) => axios.post(base, body, auth()).then((r) => changed(r.data)),
  saveVersion: (id, body) => axios.put(`${base}/${id}`, body, auth()).then((r) => changed(r.data)),
  // the Tools rail: { tools (in rail order), available (every tool that could go there), custom, max }
  sidebar: () => axios.get(`${base}/sidebar`, auth()).then((r) => r.data),
  sidebarAdd: (id) => axios.post(`${base}/sidebar/${id}`, {}, auth()).then((r) => r.data),
  sidebarRemove: (id) => axios.delete(`${base}/sidebar/${id}`, auth()).then((r) => r.data),
  dryRun: (body) => axios.post(`${base}/dry-run`, body, { ...auth(), timeout: 3 * 60 * 1000 }).then((r) => r.data), // { spec, players } → { results }
  ran: (id, body = {}) => axios.post(`${base}/${id}/ran`, body, auth()).then((r) => r.data).catch(() => null), // body: { player, market, decision } — for the feature log
  remove: (id) => axios.delete(`${base}/${id}`, auth()).then((r) => changed(r.data)),
  adminAll: () => axios.get(`${base}/admin/all`, auth()).then((r) => r.data),
  setStatus: (id, status) => axios.patch(`${base}/admin/${id}/status`, { status }, auth()).then((r) => changed(r.data)),
};

/** The message a failed call should show the agent. */
export const errorText = (err, fallback = 'Something went wrong') => {
  const d = err?.response?.data;
  if (d?.errors?.length) return `${d.error || fallback}: ${d.errors.slice(0, 3).join(' · ')}`;
  return d?.error || d?.message || err?.message || fallback;
};
